import { Device } from "api/types/device";
import LabeledField from "providers/labeledField";
import photo from "assets/svg/empty-photo.svg";

import PhotoButton from "widgets/controls/buttons/photo";
import { t } from "i18next";
import { formatDate } from "util/datelib";
import { DeviceConfiguration } from "models/devices/configuration";
import DeviceCard from "widgets/cards/device";

interface GeneralProps {
  device?: Device;
  config?: DeviceConfiguration;
}

const Installer: React.FC<GeneralProps> = ({ device, config }) => {
  return (
    <DeviceCard title={t("device.installer.details")} config={config}>
      <div className="grid grid-cols-1 gap-1 md:gap-2">
        <LabeledField
          label={`${t("device.installer.name")}: `}
          id={"name"}
          className="text-txt-xs"
          textColor="white"
        >
          <label
            className={`whitespace-normal break-words text-txt-lg text-white`}
          >
            {device?.installerName || "Name"}
          </label>
        </LabeledField>
        <LabeledField
          label={`${t("device.installer.date")}: `}
          id={"date"}
          className="text-txt-xs"
          textColor="white"
        >
          <label
            className={`whitespace-normal break-words text-txt-lg text-white`}
          >
            {formatDate(device?.installDate, "default") || "Date"}
          </label>
        </LabeledField>
        <LabeledField
          label={`${t("device.installer.location")}: `}
          id={"location"}
          className="text-txt-xs"
          textColor="white"
        >
          <label
            className={`whitespace-normal break-words text-txt-lg text-white`}
          >
            {device?.installLocation || "Location"}
          </label>
        </LabeledField>
        <div className="flex items-center justify-evenly overflow-x-auto">
          {device?.photo1 && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.photo1}
              context={"photo1"}
            />
          )}
          {device?.photo2 && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.photo2}
              context={"photo2"}
            />
          )}
          {device?.photo3 && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.photo3}
              context={"photo3"}
            />
          )}
          {device?.correctivePhoto && (
            <PhotoButton
              imageSrc={photo}
              imageKey={device?.correctivePhoto}
              color="amber"
              context={"corrective"}
            />
          )}
        </div>
      </div>
    </DeviceCard>
  );
};

export default Installer;
